import { AutoAnonymousLogin } from "src/ui/AutoAnonymousLogin";
import { CurrentUserLoader, useCurrentUser } from "src/ui/CurrentUserLoader";
import { DemoQuizView } from "src/ui/DemoQuizView";

export function DemoApp() {
  return (
    <CurrentUserLoader>
      <DemoInner />
    </CurrentUserLoader>
  );
}

function DemoInner() {
  const user = useCurrentUser();

  return (
    <>
      <AutoAnonymousLogin />
      {user ? <DemoQuizView user={user} /> : <>Loading...</>}
    </>
  );
}
